// Placeholder slice
import { createSlice } from '@reduxjs/toolkit'

const recommendationSlice = createSlice({
  name: 'recommendations',
  initialState: {},
  reducers: {},
})

export default recommendationSlice.reducer
